<template>
    <div class="mt-3 mb-3 text-center header-area">
        <Image v-if="subscriptionDetails.logo" class="img-thumbnail"
               :src="subscriptionDetails.logo" width="100" />
        <h3 class="text-center">Available Group Subscriptions</h3>
    </div>

    <div v-if="subscriptionsList.length">
        <div v-if="showSubscriptionChangeConfirmation">
            <Card>
                <template #content>
                    <p class="pt-1">
                        Buying a group subscription as an existing member will change your
                        existing subscription to the new group subscription with a renewal date a
                        year from now. The new subscription will be pro-rated (e.g. discounted) to
                        reflect the time left on your existing subscription. Press Confirm to
                        proceed with the group subscription.
                    </p>
                    <div class="flex mt-1 justify-content-center gap-3">
                        <Button label="Cancel" severity="secondary" @click="showSubscriptionChangeConfirmation = false" outlined />
                        <a :href="getOfferUrl(selectedOffer)">
                            <Button label="Confirm" />
                        </a>
                    </div>
                </template>
            </Card>
        </div>
        <div v-else v-for="offer in subscriptionsList"
             v-bind:key="offer.id"
             class="mb-2"
        >
            <div class="p-1" v-if="getOfferPrice(offer)">
                <div class="card p-3 flex-row">
                    <div class="flex flex-column">
                        <div class="text-lg font-medium text-900">{{ offer.header }}</div>
                        <div class="font-medium mt-1 text-700">{{ offer.description }}</div>
                        <div class="font-medium text-secondary mt-1 text-600">
                            {{ getOfferUsersCount(offer) }}
                            <br />
                            {{ getOfferPrice(offer) }}
                        </div>
                    </div>
                    <div class="flex mt-1 justify-content-center">
                        <Button label="Select" v-if="isShowSubscriptionChangeConfirmation" @click="showOfferConfirmationAction(offer)" />
                        <a :href="getOfferUrl(offer)" v-else>
                            <Button label="Select" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div v-if="!subscriptionsList.length" class="text-center">
        You have no available group offers at this time.
    </div>
</template>
<script>

export default {
    components: {

    },
    data () {
        return {
            showSubscriptionChangeConfirmation: false,
            selectedOffer: null,
        }
    },
    computed: {
        subscriptionDetails() {
            return window.subscriptionDetails;
        },
        subscriptionsList() {
            return window.subscriptionDetails.list;
        },
        subscriptionMember() {
            return window.subscriptionDetails.memberDetails;
        },
        isShowSubscriptionChangeConfirmation() {
            const details = this.subscriptionDetails;
            if (details.memberDetails.subscribed) {
                return true;
            }
            return false;
        }
    },
    created () {
    },
    methods: {
        _getTierById(id) {
            for (const [idx, tier] of Object.entries(this.subscriptionDetails.tiers)) {
                if (tier.id === id) return tier
            }
        },
        _getPriceById(id) {
            for (const [idx, offer] of Object.entries(this.subscriptionDetails.prices)) {
                if (offer.id === id) return offer
            }
        },
        getOfferPrice(offer) {
            if (offer.type === 'tier') {
                let tier = this._getTierById(offer.tierId)
                if (tier) {
                    let currency = tier.currency.toUpperCase();
                    let amount = (tier.yearly_price / 100).toLocaleString('en-US');
                    return 'Tier: ' + tier.name + ' - Annual (' + amount + ' ' + currency + ')'
                }
            } else if (offer.type === 'offer_with_tiers') {
                let tier = this._getTierById(offer.tierId)
                if (tier) {
                    return 'Tier: ' + tier.name
                }
            } else {
                let price = this._getPriceById(offer.offerId)
                if (price) {
                    let currency = price.currency.toUpperCase();
                    let amount = (price.amount / 100).toLocaleString('en-US');
                    return 'Offer: ' + price.nickname + ' - Annual (' + amount + ' ' + currency + ')'
                }
            }
        },
        getOfferUsersCount(offer) {
            if (offer.type === 'offer_with_tiers') {
                return `Build your own group subscription`
            } else {
                return `Total Memberships (including purchaser): ${offer.subscriptionsCount}`
            }
        },
        getOfferUrl(offer) {
            return offer.embedUrl + '?email=' + encodeURIComponent(this.subscriptionMember.email)
        },
        showOfferConfirmationAction(offer) {
            this.selectedOffer = offer
            this.showSubscriptionChangeConfirmation = true
        }
    },
}
</script>
